import { CSSResultGroup, html, LitElement, TemplateResult } from 'lit'
import { customElement, property, state } from 'lit/decorators.js'
import { StartPaymentFailedEvent } from 'components/ordering/checkout/events.js'
import { showToast } from 'components/shared/toast-host/toast-host.js'
import { style } from './start-payment-feedback.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'


@customElement('csc-start-payment-feedback')
export class CSCStartPaymentFeedback extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  @property({ type: Boolean, reflect: true, attribute: 'has-error' })
  hasError = false

  @state()
  private message: string | null = null

  override connectedCallback() {
    super.connectedCallback()

    window.addEventListener(StartPaymentFailedEvent.type, this.showErrorMessage)
  }

  override disconnectedCallback() {
    super.disconnectedCallback()

    window.removeEventListener(StartPaymentFailedEvent.type, this.showErrorMessage)
  }

  private showErrorMessage = (startPaymentFailedEvent: StartPaymentFailedEvent) => {
    this.hasError = true
    this.message = startPaymentFailedEvent.message
    showToast({ variant: 'error', message: startPaymentFailedEvent.message })
  }

  private renderAlert = () => {
    return html`
      <cse-alert variant="error">
        ${this.message}
      </cse-alert>
    `
  }

  protected override render(): TemplateResult {
    return html`
      <div class="csc-start-payment-feedback">
        ${this.message!==null ? this.renderAlert() : null}
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-start-payment-feedback': CSCStartPaymentFeedback,
  }
}
